<div [innerHTML]="safeHtml">
    <!-- Dynamic HTML content will be rendered here -->
</div>
<div style="width: 100%;">

  <div class="d-flex justify-content-end align-items-center"><div class="mr-2">Utilizator: {{mapCtrl.currentUser.name.text}}</div> <button type="button" class="btn btn-outline-secondary mr-2" (click)="reloadPage()" role="button">Deconectează</button></div>
</div>